/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Describes the result of a transaction.
 * Transactions may either succeed and commit, or fail and abort.
 */
export var TransactionResult;
(function (TransactionResult) {
    /**
     * Indicates the transaction failed.
     */
    TransactionResult[TransactionResult["Abort"] = 0] = "Abort";
    /**
     * Indicates the transaction succeeded.
     */
    TransactionResult[TransactionResult["Commit"] = 1] = "Commit";
})(TransactionResult || (TransactionResult = {}));
//# sourceMappingURL=transactionResult.js.map